<template>
    <div>
        <LaBaseForm
            :form-data="{
                id: id,
                name: name,
                email: email,
                type: type,
            }"
            id="user-form"
            :vuex-action-mutation="formAction"
            :button="isEdit ? 'Save' : 'Add new user'"
            buttonPortalTo="modalFooter"
        >
            <LaBaseInput v-model="name" name="name" label="Name" :rules="rules.name" :error="errors.name" />
            <LaBaseInput
                v-model="email"
                name="email"
                label="Email"
                :rules="rules.email"
                :error="errors.email"
                :disabled="isEdit"
            />

            <InputContainer v-if="isSuperAdmin" label="Type" name="type">
                <div class="base-input-container">
                    <LaBaseSelect
                        data-test="user-type"
                        :items="typeArr"
                        v-model="type"
                        :stretch="true"
                        :searchable="false"
                    >
                    </LaBaseSelect>
                </div>
            </InputContainer>

            <!-- Right Groups Management -->
            <div v-if="isEdit && isSuperAdmin" class="right-groups-section">
                <RightGroupsManager
                    :user-id="id"
                    :right-groups="userRightGroups"
                    @add-right-group="addRightGroup"
                    @remove-right-group="removeRightGroup"
                />
            </div>
        </LaBaseForm>
    </div>
</template>

<script>
import { computed, ref } from "vue";
import LaBaseForm from "@/components/BaseForm";
import LaBaseInput from "@/components/inputs/BaseInput";
import LaBaseSelect from "@/components/inputs/BaseSelect";
import InputContainer from "@/components/inputs/InputContainer";
import store from "@/store/store";
import { actionTypes as usersActionTypes, getterTypes as usersGetterTypes } from "@/store/Users/types";
import { getterTypes as dialogGetterTypes } from "@/store/Dialog/types";
import { isRequired, isValidEmail } from "@/helpers/rules.js";
import { getterTypes as loggedUserGetterTypes } from "@/store/LoggedUser/types";
import RightGroupsManager from "@/components/RightGroupsManager.vue";

export default {
    name: "LaUserForm",
    components: {
        LaBaseForm,
        LaBaseInput,
        LaBaseSelect,
        InputContainer,
        RightGroupsManager,
    },
    setup() {
        let user = computed(() => store.getters[dialogGetterTypes.getDialog].item);
        const userRights = computed(() => store.getters[loggedUserGetterTypes.getUserRights]);
        const errors = computed(() => store.getters[usersGetterTypes.getUserFormErrors] || {});
        const isSuperAdmin = computed(() => true || (userRights.value && userRights.value["super_admin"]));

        let name = ref("");
        let email = ref("");
        let role_code = ref("account");
        let type = ref("ltba");
        let formAction = usersActionTypes.addData;
        let isEdit = ref(false);
        let id = ref(null);
        let right_group_id = ref(null);
        let userRightGroups = ref([]);
        const typeArr = ["ltba", "performax", "all"];

        const rules = ref({
            name: [],
            email: [isRequired(), isValidEmail()],
        });

        if (user.value) {
            isEdit.value = true;
            formAction = usersActionTypes.editData;
            id.value = user.value.id;
            name.value = user.value.name || "";
            email.value = user.value.email;
            role_code.value = user.value.role_code;
            right_group_id.value = user.value.right_group_id;
            userRightGroups.value = user.value.right_groups || [];
            type.value = user.value.type || "ltba";
            // showPayments.value = user.value.showPayments;
            // permissions = user.value.permissions;
        }

        const roles = ["account", "admin", "super_admin"];

        const addRightGroup = async (rightGroup) => {
            try {
                await store.dispatch(usersActionTypes.addRightGroup, rightGroup);

                // Update local users from the store after a successful operation
                const updatedUser = store.getters[usersGetterTypes.getUserById](rightGroup.user_id);
                if (updatedUser && updatedUser.right_groups) {
                    userRightGroups.value = [...updatedUser.right_groups];
                }
            } catch (error) {
                console.error("Error adding right group:", error);
            }
        };

        const removeRightGroup = async (rightGroup) => {
            try {
                await store.dispatch(usersActionTypes.removeRightGroup, {
                    right_group_id: rightGroup.id,
                });

                // Update local users from the store after a successful operation
                const updatedUser = store.getters[usersGetterTypes.getUserById](id.value);
                if (updatedUser && updatedUser.right_groups) {
                    userRightGroups.value = [...updatedUser.right_groups];
                }
            } catch (error) {
                console.error("Error removing right group:", error);
            }
        };

        return {
            id,
            name,
            email,
            role_code,
            type,
            typeArr,
            right_group_id,
            roles,
            userRightGroups,
            // showPayments,
            formAction,
            isEdit,
            rules,
            // publishers,
            // permissions,
            isSuperAdmin,
            // selectedPublisher,
            errors,
            addRightGroup,
            removeRightGroup,
        };
    },
};
</script>

<style lang="scss" scoped>
.right-groups-section {
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid $dark-grey;
}

body.dark {
    .right-groups-section {
        border-top-color: $card-background-light;
        border-top: 1px solid $dark-grey-3;
    }
}
</style>
